import { type IDemo, RecordingTypes } from '@carboncopyco/types';
import { DemoPageTabLayout } from '../DemoPageTabLayout';
import { ActivityOverview } from './ActivityOverview';
import { DetailsCard } from './DetailsCard';
import { ScreensCard } from './ScreensCard';

export const OverviewTab = ({ demo }: { demo: IDemo }) => {
  return (
    <DemoPageTabLayout>
      <div className="w-full">
        <div className="flex gap-6 h-[305px]">
          <div className="flex flex-col flex-1">
            <DetailsCard />
          </div>
          <div className="flex flex-col flex-1">
            <ActivityOverview />
          </div>
        </div>
        {demo.recordingType !== RecordingTypes.mobile && (
          <div className="mt-6">
            <ScreensCard />
          </div>
        )}
      </div>
    </DemoPageTabLayout>
  );
};
